//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStorage } from '@/utils/storage'

export default {

	data () {
		return {
			problemItem: {}
		}
	},

	created () {

		this.problemItem = JSON.parse(getStorage('problem_item')) || {};

	},

}



// WEBPACK FOOTER //
// ./src/views/problem/problemDetail.vue